<!--
 * @Description: 
 * @Date: 2019-04-02 15:59:35
 -->
<template>
  <el-dialog
    :visible="true"
    title="《维元数服助手平台服务协议》"
    width="70%"
    :show-close="false"
    :close-on-click-modal="false"
    top="5vh"
  >
    <div class="user-protocol">
      <div v-html="protocolConents"></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { policyList } from '@/api/ajax';
export default {
  data() {
    return {
      protocolConents: ''
    };
  },
  methods: {
    close() {
      this.$emit('close', true);
    }
  },
  created() {
    policyList().then(res => {
      res.data.data.forEach(item => {
        if (item.type === 1) {
          //(更新日期)
          let publishDt = `${item.publishDt.split('-')[0]}年${
            item.publishDt.split('-')[1]
          }月${item.publishDt.split('-')[2]}日`;
          //生效日期
          let effectiveDt = `${item.effectiveDt.split('-')[0]}年${
            item.effectiveDt.split('-')[1]
          }月${item.effectiveDt.split('-')[2]}日`;
          let str = `<p style="text-align:center"><strong>${item.title}</strong></p><p><strong>&nbsp;</strong></p>
<p>更新日期：&nbsp;${publishDt}</p>
<p>生效日期：&nbsp;${effectiveDt}</p>
<p><strong>&nbsp;</strong></p>`;
          this.protocolConents = str + item.content;
        }
      });
    });
  }
};
</script>

<style lang="scss">
.user-protocol {
  height: 500px;
  overflow: auto;
}
</style>
